import styled from 'styled-components';

export const StyledCellCustomButtons = styled.div`
  display: flex;

  button {
    margin: 0 0.3rem;
  }
`;
